import Vue from 'vue';
import Router from 'vue-router';
import Home from '@/components/Home';
import Login from '@/components/Login';
import Archive from '@/components/Archive';
import Schedule from '@/components/Schedule';
import Recommendations from '@/components/Recommendations';
import FAQ from '@/components/FAQ';

Vue.use(Router);

export default new Router({
  routes: [
    {
      path: '/',
      name: 'Home',
      component: Home,
    },
    {
      path: '/login',
      name: 'Login',
      component: Login,
    },
    {
      path: '/archive/:dayNum',
      name: 'Archive',
      component: Archive,
    },
    {
      path: '/archive/:dayNum/:presentationHash',
      name: 'Archive',
      component: Archive,
    },
    {
      path: '/schedule',
      name: 'Schedule',
      component: Schedule,
    },
    {
      path: '/recommendations',
      name: 'Recommendations',
      component: Recommendations,
    },
    {
      path: '/faq',
      name: 'FAQ',
      component: FAQ,
    },
  ],
  scrollBehavior (to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    } else {
      return { x: 0, y: 0 }
    }
  }
});


// WEBPACK FOOTER //
// ./src/router/index.js